// @flow
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { message } from 'antd'
import gql from 'graphql-tag'
import Path from 'routes/path'
import {
  actions as favoriteActions,
  type State as FavoriteState,
} from 'redux/modules/favorite'
import { setUIState, containerIds } from 'redux/modules/ui'
import MainTemplate from 'components/templates/MainTemplate'
import { headerFragment } from 'common/fragments/www'
import FavoriteListDetailPage from 'components/pages/FavoriteListDetailPage'
import FavoriteCardListContainer from 'containers/organisms/FavoriteCardList'
import ErrorPage from 'containers/pages/ErrorPage'
import { accountLoginUrl } from 'frontend_core/dist/helpers/url'

type PropTypes = {
  favorite: FavoriteState,
  match: {
    params: {
      favoriteListId: number,
    },
  },
  localUser: {
    username: string,
  },
  actions: {
    setFavoriteListDetail: Function,
    fetchFavoriteListDetail: Function,
    updateFavoriteList: Function,
    setUIState: Function,
    fetchFavoriteList: Function,
    adjustFavoriteListDetail: Function,
  },
  history: {
    replace: Function,
    push: Function,
  },
  location: {
    pathname: string,
  },
  ui: {
    isOpenDeleteFavoriteSelectModal: boolean,
    isOpenChangeFavoriteListNameModal: boolean,
    isOpenSelectFavoriteListItemModal: boolean,
    isOpenDeleteFavoriteListItemModal: boolean,
    isSubmittedCreateNewListName: boolean,
    isOpenInputFavorite: boolean,
    newListName: string,
    changeFavoriteListName: string,
    inputFavoriteListName: string,
    selectFavoriteListItemModal: {
      isOpen: boolean,
      roomId: ?string,
    },
    deleteFavoriteListItemModal: {
      isOpen: boolean,
      roomId: ?string,
    },
  },
}

class FavoriteListDetailPageContainer extends React.Component<PropTypes> {
  static async getInitialProps({ req, res, params, config, isLogin }) {
    if (!isLogin)
      return { redirect: { to: accountLoginUrl(config), status: 302 } }
    return
  }

  constructor(props: PropTypes) {
    super(props)
    this.onReachedBottom = this.onReachedBottom.bind(this)
    props.actions.setUIState(containerIds.FAVORITE, {
      isOpenDeleteFavoriteSelectModal: false,
      isOpenChangeFavoriteListNameModal: false,
      newListName: '',
      changeFavoriteListName: '',
      isSubmittedCreateNewListName: false,
      isOpenInputFavorite: false,
    })
  }

  componentDidMount() {
    const { match, actions, localUser, favorite } = this.props
    const favoriteListId = parseInt(match.params.favoriteListId, 10)
    const foundFavoriteList = favorite.favoriteList.find(
      favoriteList => favoriteList.id === favoriteListId,
    )

    window.scrollTo(0, 0)

    if (
      !favorite.isSuccessFetchFavoriteListDetail ||
      favorite.favoriteListDetail.id !== favoriteListId
    ) {
      actions.initializeFavoriteListDetail({
        userId: localUser.username,
        favoriteListId,
        initialFavoriteList: foundFavoriteList || {},
      })
    }
    actions.fetchFavoriteList({
      userId: this.props.localUser.username,
      silent: favorite.isSuccessFetchFavoriteList,
    })
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { favorite, history, location } = this.props
    const {
      failedCreateFavoriteListMessage,
      failedUpdateFavoriteListMessage,
      failedDeleteFavoriteListMessage,
      failedCreateFavoriteMessage,
      failedDeleteFavoriteMessage,
      failedFavoriteMemoMessage,
      failedFetchFavoriteListDetailMessage,
    } = favorite
    if (
      favorite.isSuccessDeleteFavoriteList &&
      !prevProps.favorite.isSuccessDeleteFavoriteList
    ) {
      history.push(location.pathname)
      history.replace(Path.favoriteLists())
    }

    if (
      failedCreateFavoriteListMessage &&
      !prevProps.favorite.failedCreateFavoriteListMessage
    ) {
      message.warning(failedCreateFavoriteListMessage)
    } else if (
      failedUpdateFavoriteListMessage &&
      !prevProps.favorite.failedUpdateFavoriteListMessage
    ) {
      message.warning(failedUpdateFavoriteListMessage)
    } else if (
      failedDeleteFavoriteListMessage &&
      !prevProps.favorite.failedDeleteFavoriteListMessage
    ) {
      message.warning(failedDeleteFavoriteListMessage)
    }

    if (
      failedDeleteFavoriteMessage &&
      !prevProps.favorite.failedDeleteFavoriteMessage
    ) {
      message.warning(failedDeleteFavoriteMessage)
    } else if (
      failedCreateFavoriteMessage &&
      !prevProps.favorite.failedCreateFavoriteListMessage
    ) {
      message.warning(failedCreateFavoriteMessage)
    }

    if (
      failedFavoriteMemoMessage &&
      !prevProps.favorite.failedFavoriteMemoMessage
    ) {
      message.warning(failedFavoriteMemoMessage)
    }
    if (
      failedFetchFavoriteListDetailMessage &&
      !prevProps.favorite.failedFetchFavoriteListDetailMessage
    ) {
      message.warning(failedFetchFavoriteListDetailMessage)
    }
  }

  onReachedBottom: Function
  onReachedBottom() {
    const { match, actions, localUser, favorite } = this.props
    const {
      isFetchFavoriteListDetailEnd,
      isSuccessFetchFavoriteListDetail,
      failedFetchFavoriteListDetailMessage,
    } = favorite
    if (!isFetchFavoriteListDetailEnd) {
      if (
        isSuccessFetchFavoriteListDetail &&
        !failedFetchFavoriteListDetailMessage
      ) {
        const favoriteListId = parseInt(match.params.favoriteListId, 10)
        actions.fetchFavoriteListDetail({
          userId: localUser.username,
          favoriteListId,
          page: favorite.fetchFavoriteListDetailPage,
        })
      }
    }
  }

  render() {
    const {
      favorite: {
        favoriteList,
        favoriteListDetail,
        isSuccessFetchFavoriteListDetail,
        failedFetchFavoriteListDetailMessage,
      },
      localUser,
      history,
      location,
      actions,
      match,
    } = this.props
    const {
      isOpenDeleteFavoriteSelectModal,
      isOpenChangeFavoriteListNameModal,
      selectFavoriteListItemModal,
      deleteFavoriteListItemModal,
      isOpenInputFavorite,
      inputFavoriteListName,
      isSubmittedCreateNewListName,
      newListName,
      changeFavoriteListName,
    } = this.props.ui
    const title = i18n.t('server.www.favoriteList.title')
    const filteredFavorites = favoriteListDetail.favorites
      ? favoriteListDetail.favorites.filter(
          item => item.id === selectFavoriteListItemModal.roomId,
        )
      : []
    const registeredFavoriteLists = filteredFavorites.length
      ? filteredFavorites[0].registered_favorite_lists
      : []

    //  お気に入りリストが存在しないときに404エラー
    if (
      !isSuccessFetchFavoriteListDetail &&
      failedFetchFavoriteListDetailMessage
    ) {
      return <ErrorPage status={404} />
    }

    return (
      <MainTemplate
        title={title}
        description={i18n.t('server.shared.default_description', { title })}
        hideMustHeader
        {...this.props}
      >
        <FavoriteListDetailPage
          favoriteListDetail={favoriteListDetail}
          isLoading={
            !isSuccessFetchFavoriteListDetail &&
            !failedFetchFavoriteListDetailMessage
          }
          onReachedBottom={this.onReachedBottom}
          onClickBackLink={(e: Event) => {
            e.preventDefault()
            history.push(location.pathname)
            history.replace(Path.favoriteLists())
          }}
          favoriteList={favoriteList}
          onClickChangeListName={() => {
            actions.updateFavoriteList({
              userId: localUser.username,
              favoriteListId: parseInt(match.params.favoriteListId, 10),
              name: changeFavoriteListName,
            })
            actions.setUIState(containerIds.FAVORITE, {
              isOpenChangeFavoriteListNameModal: false,
            })
          }}
          onClickDeleteFavoriteList={() => {
            actions.deleteFavoriteList({
              userId: localUser.username,
              favoriteListId: parseInt(match.params.favoriteListId, 10),
            })
            actions.setUIState(containerIds.FAVORITE, {
              isOpenDeleteFavoriteSelectModal: false,
            })
          }}
          openDeleteFavoriteSelectModal={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isOpenDeleteFavoriteSelectModal: true,
            })
          }}
          closeDeleteFavoriteSelectModal={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isOpenDeleteFavoriteSelectModal: false,
            })
          }}
          isOpenDeleteFavoriteSelectModal={isOpenDeleteFavoriteSelectModal}
          openChangeFavoriteListNameModal={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isOpenChangeFavoriteListNameModal: true,
            })
          }}
          closeChangeFavoriteListNameModal={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isOpenChangeFavoriteListNameModal: false,
            })
          }}
          isOpenChangeFavoriteListNameModal={isOpenChangeFavoriteListNameModal}
          selectFavoriteListItemModal={selectFavoriteListItemModal}
          deleteFavoriteListItemModal={deleteFavoriteListItemModal}
          onClickCloseSelectFavoriteListItemModal={() => {
            actions.setUIState(containerIds.FAVORITE, {
              selectFavoriteListItemModal: {
                isOpen: false,
                roomId: null,
              },
            })
            actions.adjustFavoriteListDetail({
              favoriteListId: favoriteListDetail.id,
              favorableId: selectFavoriteListItemModal.roomId,
            })
          }}
          onClickCloseDeleteFavoriteListItemModal={() => {
            actions.setUIState(containerIds.FAVORITE, {
              deleteFavoriteListItemModal: {
                isOpen: false,
                roomId: null,
              },
            })
          }}
          onClickDeleteFavoriteListItem={() => {
            actions.removeFavorite({
              userId: localUser.username,
              roomId: deleteFavoriteListItemModal.roomId,
              favoriteListId: favoriteListDetail.id,
            })
            actions.setUIState(containerIds.FAVORITE, {
              deleteFavoriteListItemModal: {
                isOpen: false,
                roomId: null,
              },
            })
          }}
          isOpenInputFavorite={isOpenInputFavorite}
          onClickOpenInputFavorite={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isOpenInputFavorite: true,
            })
          }}
          onClickCloseInputFavorite={() => {
            actions.setUIState(containerIds.FAVORITE, {
              isOpenInputFavorite: false,
            })
          }}
          isSubmittedCreateNewListName={isSubmittedCreateNewListName}
          newListName={newListName}
          errorMessageFavoriteSelectModal={
            isSubmittedCreateNewListName &&
            !newListName &&
            i18n.t('favorite.inputGuide')
          }
          onClickAddFavoriteList={favoriteListId => {
            actions.addFavorite({
              userId: localUser.username,
              roomId: selectFavoriteListItemModal.roomId,
              favoriteListId,
            })
          }}
          onClickRemoveFavoriteList={favoriteListId => {
            actions.removeFavorite({
              userId: localUser.username,
              roomId: selectFavoriteListItemModal.roomId,
              favoriteListId,
            })
          }}
          registeredFavoriteLists={registeredFavoriteLists}
          onChangeChangeListName={e => {
            actions.setUIState(containerIds.FAVORITE, {
              changeFavoriteListName: e.target.value,
            })
          }}
          changeFavoriteListName={changeFavoriteListName}
          onClickCreateFavoriteList={(e, roomId) => {
            e.preventDefault()
            actions.createFavoriteList({
              userId: localUser.username,
              roomId,
              name: inputFavoriteListName,
            })
            actions.setUIState(containerIds.FAVORITE, {
              isOpenInputFavorite: false,
            })
          }}
          onChangeFavoriteListName={(e: SyntheticInputEvent<*>) => {
            actions.setUIState(containerIds.FAVORITE, {
              inputFavoriteListName: e.target.value,
            })
          }}
        >
          <FavoriteCardListContainer />
        </FavoriteListDetailPage>
      </MainTemplate>
    )
  }
}

const headerQuery = gql`
query HeaderQuery {
  ${headerFragment}
}
`

const withData = graphql(headerQuery)(FavoriteListDetailPageContainer)

function mapStateToProps(state: Object) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...favoriteActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withData),
)



// WEBPACK FOOTER //
// ./src/containers/pages/FavoriteListDetailPage.jsx